import welcomePageDictionary from '@pages/welcome/i18n/ru/welcome.dic.json';

export const welcomePage = {
  WELCOME_PAGE: welcomePageDictionary,
};

export const welcomePageNamespaces = Object.keys(welcomePage);
